import {
  GlobalSearchView,
} from '@/views';

const routes = {
  privatePaths: [
    {
      path: 'search',
      component: GlobalSearchView,
      props: ({ query }) => ({
        query: typeof query.q === 'string' ? query.q : null,
      }),
      /* children: [
        {
          path: '',
          components: {
            tickets: TicketsListView,
            knowledgeItems: KnowledgeItemsListView,
          },
        },
        {
          path: '/:id',
          components: {
            tickets: TicketDetailView,
            knowledgeItems: KnowledgeItemsDetailView,
          },
        },
      ], */
    },
  ],
  publicPaths: [],
};

export default routes;
